import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export class CustomTranslateLoader implements TranslateLoader {
  contentHeader = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(
    private httpClient: HttpClient
  ) {}
  
  getTranslation(lang: string): Observable<any> {
    const translationBaseUrl = environment.translationApiUrl;
    const apiAddress = `${translationBaseUrl}/interface-translation-value/json/${environment.cncsApplicationId}/${lang}`;
    return this.httpClient
      .get<Record<string, unknown>>(apiAddress)
      .pipe(catchError((_) => of({})));
  }
}
